"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const mapIconKeyToUiKit = icon => {
  switch (icon) {
    case 'PROFILE':
      return 'user';
    case 'CONTACT':
      return 'comments';
    default:
      if (icon) {
        return icon.toLowerCase();
      }
      return icon;
  }
};
var _default = exports.default = mapIconKeyToUiKit;